import React from 'react';
import './light-header.css';

export default function LightHeader() {
  return (
    <section>
      <h1 className="light-header-h1">Chord Courier</h1>
      <h2 className="light-header-h2">Delivering fresh chords</h2>
    </section>
  );
}
